import { render, staticRenderFns } from "./create-admin-user.vue?vue&type=template&id=2fc76f4a"
import script from "./create-admin-user.vue?vue&type=script&lang=ts"
export * from "./create-admin-user.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports